// import React, { useState, useEffect } from 'react';
// import './OneToOneReview.css';
// import './createadmin.css';
// import sortIcon from './images/sort.png';

// const ReferralGiven = () => {
//   const [userData, setUserData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'ascending' });

//   const formatDate = (date) => {
//     const parsedDate = new Date(date);
//     return `${parsedDate.getDate()}-${parsedDate.toLocaleString('default', { month: 'short' })}-${parsedDate.getFullYear()}`;
//   };

//   const fetchData = async (query = '') => {
//     setLoading(true);
//     setErrorMessage('');
//     try {
//       const url = query
//         ? `${process.env.REACT_APP_SERVER_IP}/api/admin/referral?searchQuery=${query}`
//         : `${process.env.REACT_APP_SERVER_IP}/api/admin/referral`;

//       const response = await fetch(url, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`,
//         },
//       });
//       const data = await response.json();

//       if (Array.isArray(data)) {
//         setUserData(data);
//         setFilteredData(data);
//       } else {
//         setErrorMessage('Invalid data format');
//       }
//       if (data.length === 0) {
//         setErrorMessage('No results found.');
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setErrorMessage('Error fetching data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleSearch = (e) => {
//     const query = e.target.value.trim();
//     setSearchQuery(query);

//     if (query === '') {
//       setFilteredData(userData);
//       setErrorMessage('');
//     } else {
//       const filtered = userData.filter((entry) => {
//         const fullName = `${entry.userId?.firstName || ''} ${entry.userId?.lastName || ''}`.toLowerCase();
//         return fullName.includes(query.toLowerCase());
//       });
//       setFilteredData(filtered);
//     }
//   };

//   const sortData = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   const sortedData = [...filteredData].sort((a, b) => {
//     if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'ascending' ? -1 : 1;
//     if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'ascending' ? 1 : -1;
//     return 0;
//   });

//   return (
//     <div className="contain">
//       <main className="main-content">
//         <div className="table-container">
//           <h2>Referral View Slip</h2>
//           <div className="search-container">
//             <input type="text" placeholder="Search User" value={searchQuery} onChange={handleSearch} />
//           </div>
//           {errorMessage && <p className="error-message">{errorMessage}</p>}
//           <table className="table-heading">
//             <thead>
//               <tr>
//                 <th onClick={() => sortData('date')}>Date <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('name')}>Name <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('metWith')}>Reference Name <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('companyName')}>Referral Name <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('companyName')}>Referral Company Name / Referral Brand Name <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('contactNumber')}>Contact Number <img src={sortIcon} alt="Sort" /></th>
//                 <th onClick={() => sortData('comments')}>Comments <img src={sortIcon} alt="Sort" /></th>
//               </tr>
//             </thead>
//             <tbody>
//               {Array.isArray(filteredData) && filteredData.length > 0 ? (
//                 sortedData.map((entry, index) => (
//                   <tr key={index}>
//                     <td>{entry.date ? formatDate(entry.date) : 'No Date'}</td>
//                     <td>{entry.name || 'Unknown'}</td>
//                     <td>{entry.referenceName?.firstName && entry.referenceName?.lastName ? `${entry.referenceName.firstName} ${entry.referenceName.lastName}` : '--'}</td>
//                     <td>{entry.referralName || 'No Referral Name'}</td>
//                     <td>{entry.company || 'No Company Name'}</td>
//                     <td>{entry.phone || 'No Contact Number'}</td>
//                     <td>{entry.comments ? entry.comments : 'No Comments'}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="7">No data available</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default ReferralGiven;




import React, { useState, useEffect } from 'react';
// import './OneToOneReview.css';
import './createadmin.css';
import './ReferralGiven.css'; 
import sortIcon from './images/sort.png';
import msortIcon from './images/msort.png';

const ReferralGiven = () => {
  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    return `${parsedDate.getDate()}-${parsedDate.toLocaleString('default', { month: 'short' })}-${parsedDate.getFullYear()}`;
  };

  const fetchData = async () => {
    setLoading(true);
    setErrorMessage('');
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/referral`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await response.json();
      if (Array.isArray(data)) {
        setUserData(data);
        setFilteredData(data);
      } else {
        setErrorMessage('Invalid data format');
      }
      if (data.length === 0) {
        setErrorMessage('No results found.');
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase().trim();
    setSearchQuery(query);

    if (query === '') {
      setFilteredData(userData);
      setErrorMessage('');
      return;
    }

    const filtered = userData.filter((entry) => {
      const name = (entry.name || '').toLowerCase().trim();
      const referenceName = `${entry.referenceName?.firstName || ''} ${entry.referenceName?.lastName || ''}`.toLowerCase().trim();
      const referralName = (entry.referralName || '').toLowerCase().trim();

      return name.includes(query) || referenceName.includes(query) || referralName.includes(query);
    });

    setFilteredData(filtered);
  };

  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = [...filteredData].sort((a, b) => {
    let valA, valB;

    if (sortConfig.key === 'date') {
      valA = new Date(a.date);
      valB = new Date(b.date);
      return sortConfig.direction === 'ascending' ? valA - valB : valB - valA;
    } else if (sortConfig.key === 'referenceName') {
      valA = `${a.referenceName?.firstName || ''} ${a.referenceName?.lastName || ''}`.toLowerCase().trim();
      valB = `${b.referenceName?.firstName || ''} ${b.referenceName?.lastName || ''}`.toLowerCase().trim();
    } else {
      valA = (a[sortConfig.key] || '').toString().toLowerCase();
      valB = (b[sortConfig.key] || '').toString().toLowerCase();
    }

    return sortConfig.direction === 'ascending' ? valA.localeCompare(valB) : valB.localeCompare(valA);
  });

  const isMobile = windowWidth <= 768;

  return (
    <div className="contain">
      <main className="main-content">
        <div className="table-containerOne">
        <h2  className='AddOneToOne'>View Referral</h2>
          <div className="search-containerOne">
            <input type="text" placeholder="Search User" value={searchQuery} onChange={handleSearch} />
          </div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}

          {!isMobile ? (
            <table className="table-heading">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th onClick={() => sortData('date')}>Date <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('name')}>Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('referenceName')}>Reference Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('referralName')}>Referral Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('company')}>Referral Company Name <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('phone')}>Contact Number <img src={sortIcon} alt="Sort" /></th>
                  <th onClick={() => sortData('comments')}>Comments <img src={sortIcon} alt="Sort" /></th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((entry, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{entry.date ? formatDate(entry.date) : 'No Date'}</td>
                      <td>{entry.name || 'Unknown'}</td>
                      <td>{entry.referenceName?.firstName && entry.referenceName?.lastName
                        ? `${entry.referenceName.firstName} ${entry.referenceName.lastName}` : '--'}</td>
                      <td>{entry.referralName || 'No Referral Name'}</td>
                      <td>{entry.company || 'No Company Name'}</td>
                      <td>{entry.phone || 'No Contact Number'}</td>
                      <td>{entry.comments || 'No Comments'}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="8">No data available</td></tr>
                )}
              </tbody>
            </table>
          ) : (
            <div className="mobile-scroll-table-add">
            <div className="mobile-scroll-wrapper">
 
              <table>
                <tbody>
                  <tr>
                    <th>S.No</th>
                    {sortedData.map((_, i) => <td key={`sno-${i}`}>{i + 1}</td>)}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Date <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`date-${i}`}>{entry.date ? formatDate(entry.date) : 'Unknown'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`name-${i}`}>{entry.name || 'Unknown'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Reference Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`refname-${i}`}>{entry.referenceName?.firstName && entry.referenceName?.lastName
                        ? `${entry.referenceName.firstName} ${entry.referenceName.lastName}` : '--'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Referral Name <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`referral-${i}`}>{entry.referralName || 'No Referral Name'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Company <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`company-${i}`}>{entry.company || 'No Company'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Phone <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`phone-${i}`}>{entry.phone || 'No Contact'}</td>
                    ))}
                  </tr>
                  <tr>
                    <th onClick={() => sortData('date')}>Comments <img src={msortIcon} alt="Sort" className="sort-iconm" /></th>
                    {sortedData.map((entry, i) => (
                      <td key={`comments-${i}`}>{entry.comments || 'No Comments'}</td>
                    ))}
                  </tr>
                </tbody>
              </table>
         
            </div></div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ReferralGiven;
